$(document).ready(function () {
  // obecné
  var bodyWidth = window.innerWidth;

  // události při resize okna
  $(window).on('resize', function () {
    // ošetření, zda se velikost změnila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
  });

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.nav-switcher').hasClass('is-open')) {
      $('.nav-switcher, .nav').removeClass('is-open');
      $('body').removeClass('is-unscrollable');
    } else {
      $('.nav-switcher, .nav').addClass('is-open');
      $('body').addClass('is-unscrollable');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.nav-switcher, .nav').removeClass('is-open');
    $('body').removeClass('is-unscrollable');
  }
  // spouštěč
  $('.nav-switcher').on('click', function () {
    switchMenu();
  });

  // spouštěč
  $('.nav a').on('click', function () {
    resetMenu();
  });

  // scroll top
  function scrollTop() {
    if ($(this).scrollTop() > 250) {
      $('.scrolltop').addClass('is-active');
    } else {
      $('.scrolltop').removeClass('is-active');
    }
  }

  // zmenšená hlavička
  function compactHeader() {
    if ($(this).scrollTop() > 10) {
      $('.header').addClass('header--compact');
    } else {
      $('.header').removeClass('header--compact');
    }
  }

  // události při načtení stránky
  $(window).on('load', function () {
    // AOS fix pro první načítání
    AOS.refresh();
  });

  // události při scroolování
  $(window).on('scroll', function () {
    // scroll top
    scrollTop();
    // zmenšená hlavička
    compactHeader();
  });

  if ($('.js-nav').length) {
    var spy = new Gumshoe('.js-nav a');
  }

  // slider v detailu produktu
  if ($('.preview').length) {
    jQuery('.preview__image').slick({
      lazyLoad: 'ondemand',
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      //prevArrow: $('.preview__control--prev'),
      //nextArrow: $('.preview__control--next'),
      fade: false,
      autoplay: false,
      adaptiveHeight: true,
      autoplaySpeed: 5000,
      asNavFor: '.preview__thumbnails',
    });

    jQuery('.preview__thumbnails').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      arrows: true,
      fade: false,
      autoplay: false,
      asNavFor: '.preview__image',
      focusOnSelect: true,
    });
  }

  // modal okna
  if ($('.modal').length) {
    modal();
  }
});
